import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { Button, Modal } from "react-bootstrap";
import * as Yup from "yup";
import TextField from "../../textField/TextField";
import makeRequest from "../../../utils/makeRequest";
import * as urls from "../../../utils/URLConst";
import toastNotify from "../../../utils/ToastNotify";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../../redux/reducers/layout";


const AddCompanyMdl = ({
    isOpen,
    handleIsCompanyMdl,
    fetchCompanyList
}) => {

    const dispatch = useDispatch();

    async function addProducts(val) {
        try {
            dispatch(handleLoader(true));
            const config = {};
            var payload = {
                VENDOR_NM: val.companyNm,
            };
            const result = await makeRequest("POST", urls.setClientVederName, payload, config);

            if (result.STATUS === "0") {
                toastNotify(result.MESSAGE, "success");
                fetchCompanyList();
                handleIsCompanyMdl();
            } else {
                toastNotify(result.MESSAGE, "error");
            }
        } catch (error) {
            // Ingore Case
        } finally {
            dispatch(handleLoader(false));
        }
    }

    return (

        <Modal
            backdrop="static"
            keyboard={false}
            size="sm"
            show={isOpen}
            onHide={handleIsCompanyMdl}
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New Company</Modal.Title>
            </Modal.Header>

            <Formik
                enableReinitialize={true}
                initialValues={{ companyNm: "" }}
                validationSchema={Yup.object({
                    companyNm: Yup.string().required("Company Name is required field.")
                })}
                onSubmit={(values) => {
                    addProducts(values);
                }}
            >
                {({ values, handleChange, handleBlur }) => (
                    <Form>
                        <Modal.Body>
                            <TextField
                                label="Company Name"
                                name="companyNm"
                                id="companyNm"
                                required
                                maxLength={50}
                                value={values.companyNm}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <ErrorMessage
                                name="companyNm"
                                component="div"
                                className="error-msg"
                            />
                        </Modal.Body>
                        <Modal.Footer className=" py-2">
                            <Button
                                variant="primary"
                                type="submit"
                                className=" btn-sm"
                            >
                                Submit
                            </Button>
                            <Button
                                variant="secondary"
                                type="button"
                                className="btn-sm"
                                onClick={handleIsCompanyMdl}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal >
    );
};

export default AddCompanyMdl;
